<template>

  <div class="onboarding">
    <IntroVideo v-if="showIntroVideo && !buddyCreationDone" :open="showIntroVideo"
                v-on:introVideoNextClicked="moveToTutorial"></IntroVideo>

    <Tutorial v-if="showTutorial" :open="showTutorial"
              v-on:nextStepClicked="moveToBuddyCreation"
              v-on:backToVideo="backToVideoClicked" :buddy="buddy"></Tutorial>

    <NamePickPopup v-if="buddyCreationDone" :open="buddyCreationDone"
                   v-on:nextStepClicked="openTutorial2"
                   v-on:backToBuddyCreation="backToBuddyCreationClicked"></NamePickPopup>

    <Tutorial2 v-if="showTutorial2" :open="showTutorial2" :buddyName="buddyName" :buddy="buddy"
               v-on:nextStepClicked="finishOnboarding"></Tutorial2>
  </div>

</template>

<script>
  import IntroVideo from "../../../components/StudentPlatform/Onboarding/IntroVideo";
  import Tutorial from "../../../components/StudentPlatform/Onboarding/Tutorial";
  import Tutorial2 from "../../../components/StudentPlatform/Onboarding/Tutorial2";
  import NamePickPopup from "../../../components/StudentPlatform/Onboarding/NamePickPopup";

  export default {
    name: "Onboarding",
    components: { IntroVideo, Tutorial, Tutorial2, NamePickPopup },
    props: {
      open: Boolean,
      buddyCreationDone: Boolean,
      buddy: Object,
    },
    data() {
      return {
        show: this.open,
        showIntroVideo: true,
        showTutorial: false,
        showNamePick: false,
        showTutorial2: false,
        buddyName: "",
      }
    },
    computed: {

    },
    mixins: [],
    methods: {

      moveToTutorial() {
        //move to tutorial view
        this.showIntroVideo = false;
        this.showTutorial = true;
        this.showNamePick = false;
      },

      moveToBuddyCreation() {
        this.showIntroVideo = false;
        this.showTutorial = false;
        this.showNamePick = false;
        this.$emit("startBuddyCreation");
      },

      backToVideoClicked() {
        this.showIntroVideo = true;
        this.showTutorial = false;
        this.showNamePick = false;
      },

      backToBuddyCreationClicked() {
        this.showIntroVideo = false;
        this.showTutorial = false;
        this.showNamePick = false;
        this.$emit("startBuddyCreation");
      },

      openTutorial2 ( buddyName) {
        this.buddyName = buddyName;
        this.showIntroVideo = false;
        this.showTutorial = false;
        this.showTutorial2 = true;
        this.showNamePick = false;
      },

      finishOnboarding() {
        this.showIntroVideo = false;
        this.showTutorial = false;
        this.showNamePick = false;
        this.$emit("onboardingFinished", this.buddyName);
      }

    },
    mounted(){

    },
    created() {

    },
  }


</script>

<style lang="scss" scoped>

</style>